// @core/api/endpoints/task/unassign_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Unassign task
 * Removes the current assignee from the task, leaving it unassigned. The task remains visible but is no longer in anyone's assignment queue.
 */
export async function UnassignTask(
  task_id: string,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/assign`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.delete<TaskResponse>(requestPath, requestOptions);
}
